<template>
  <div class="main-container">
    <!-- 标题 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('upgrade.orderList') }}</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="addUpgradeHandle()"
        >{{ $t('upgrade.addUpgrade') }}</el-button>
      </div>
      
      <!-- 搜索工具栏 -->
      <el-form :inline="true" :model="searchForm" class="form-container">
        <el-form-item :label="$t('upgrade.appointmentId')">
          <el-input v-model="searchForm.appointmentId" :placeholder="$t('upgrade.appointmentId')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('upgrade.upgradeType')">
          <el-input v-model="searchForm.upgradeType" :placeholder="$t('upgrade.upgradeType')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.status')">
          <el-select v-model="searchForm.status" :placeholder="$t('common.selectStatus')" clearable>
            <el-option :label="$t('upgrade.applying')" value="申请中"></el-option>
            <el-option :label="$t('upgrade.approved')" value="已批准"></el-option>
            <el-option :label="$t('upgrade.rejected')" value="已拒绝"></el-option>
            <el-option :label="$t('upgrade.completed')" value="已完成"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList()">{{ $t('common.search') }}</el-button>
          <el-button @click="resetSearch()">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 数据表格 -->
      <el-table
        :data="dataList"
        border
        v-loading="dataListLoading"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          :label="$t('table.index')"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="id"
          header-align="center"
          align="center"
          width="100"
          :label="$t('table.id')"
        ></el-table-column>
        <el-table-column
          prop="appointmentId"
          header-align="center"
          align="center"
          width="100"
          :label="$t('upgrade.appointmentId')"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="viewAppointment(scope.row.appointmentId)">
              {{ scope.row.appointmentId }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="upgradeType"
          header-align="center"
          align="center"
          :label="$t('upgrade.upgradeType')"
        ></el-table-column>
        <el-table-column
          prop="upgradeDetails"
          header-align="center"
          align="center"
          :label="$t('upgrade.upgradeDetails')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="additionalCost"
          header-align="center"
          align="center"
          :label="$t('upgrade.additionalCost')"
        >
          <template slot-scope="scope">
            ${{ scope.row.additionalCost }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          header-align="center"
          align="center"
          width="100"
          :label="$t('common.status')"
        >
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusLabel(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="upgradeTime"
          header-align="center"
          align="center"
          width="180"
          :label="$t('upgrade.createTime')"
        >
          <template slot-scope="scope">
            {{ scope.row.upgradeTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          header-align="center"
          align="center"
          width="200"
          :label="$t('upgrade.operation')"
        >
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === '申请中'" type="text" size="small" @click="updateStatusHandle(scope.row.id, '已批准')">{{ $t('upgrade.approve') }}</el-button>
            <el-button v-if="scope.row.status === '申请中'" type="text" size="small" @click="updateStatusHandle(scope.row.id, '已拒绝')">{{ $t('upgrade.reject') }}</el-button>
            <el-button v-if="scope.row.status === '已批准'" type="text" size="small" @click="updateStatusHandle(scope.row.id, '已完成')">{{ $t('upgrade.complete') }}</el-button>
            <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" style="color: #F56C6C">{{ $t('upgrade.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页控件 -->
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </el-card>
    
    <!-- 预约详情对话框 -->
    <el-dialog
      :title="$t('upgrade.appointmentDetail') || '预约详情'"
      :visible.sync="appointmentDialogVisible"
      width="700px"
    >
      <div v-if="appointmentDetail">
        <el-descriptions :column="2" border>
          <el-descriptions-item :label="$t('upgrade.appointmentId')">{{ appointmentDetail.id }}</el-descriptions-item>
          <el-descriptions-item :label="$t('coach.id') || '教练编号'">{{ appointmentDetail.jiaolianbianhao }}</el-descriptions-item>
          <el-descriptions-item :label="$t('coach.name') || '教练姓名'">{{ appointmentDetail.jiaolianxingming }}</el-descriptions-item>
          <el-descriptions-item :label="$t('user.account') || '用户账号'">{{ appointmentDetail.zhanghao }}</el-descriptions-item>
          <el-descriptions-item :label="$t('user.name') || '用户姓名'">{{ appointmentDetail.xingming }}</el-descriptions-item>
          <el-descriptions-item :label="$t('user.phone') || '手机号码'">{{ appointmentDetail.shouji }}</el-descriptions-item>
          <el-descriptions-item :label="$t('appointment.appointmentTime') || '预约时间'" :span="2">{{ appointmentDetail.yuyueshijian | formatDate }}</el-descriptions-item>
          <el-descriptions-item :label="$t('appointment.description') || '预约说明'" :span="2">{{ appointmentDetail.yuyueshuoming }}</el-descriptions-item>
          <el-descriptions-item :label="$t('common.status')">
            <el-tag :type="getStatusType(appointmentDetail.status)">{{ appointmentDetail.status }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('appointment.auditStatus') || '审核状态'">{{ appointmentDetail.sfsh }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="appointmentDialogVisible = false">{{ $t('common.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from '@/utils/date.js'

export default {
  filters: {
    formatDate(time) {
    console.log("time",time);
    
      if (time) {
        return formatDate(new Date(time), 'YYYY-MM-DD HH:mm:ss')
      }
      return ''
    }
  },
  data() {
    return {
      searchForm: {
        appointmentId: '',
        upgradeType: '',
        status: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      appointmentDialogVisible: false,
      appointmentDetail: null
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: '/jiaolianyuyue/upgrade/page',
        method: 'get',
        params: {
          page: this.pageIndex,
          limit: this.pageSize,
          appointmentId: this.searchForm.appointmentId || undefined,
          upgradeType: this.searchForm.upgradeType || undefined,
          status: this.searchForm.status || undefined
        }
      }).then(({ data }) => {
        console.log("upgradeList",data);
        
        if (data && data.code === 0) {
          this.dataList = data.page.list
          this.totalPage = data.page.totalCount
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 跳转到添加升级页面
    addUpgradeHandle() {
      this.$router.push({ name: 'upgrade-add' })
    },
    // 查看预约详情
    viewAppointment(appointmentId) {
      this.$http({
        url: `/jiaolianyuyue/info/${appointmentId}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.appointmentDetail = data.data
          this.appointmentDialogVisible = true
        } else {
          this.$message.error(this.$t('upgrade.fetchDetailFailed'))
        }
      }).catch(() => {
        this.$message.error(this.$t('upgrade.fetchDetailFailed'))
      })
    },
    // 更新升级状态
    updateStatusHandle(id, status) {
      const statusLabel = this.getStatusLabel(status)
      this.$confirm(
        this.$t('upgrade.confirmStatusChange', { status: statusLabel }), 
        this.$t('common.tip'), 
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      ).then(() => {
        // 确保 id 是数字类型，因为后端期望 Long 类型
        const upgradeId = typeof id === 'string' ? parseInt(id, 10) : id
        console.log('更新状态参数:', { upgradeId: upgradeId, status, idType: typeof upgradeId })
        
        // 注意：后端期望的参数名是 upgradeId 而不是 id
        // 使用 params 发送查询参数，与其他状态更新方法保持一致
        this.$http({
          url: '/jiaolianyuyue/upgrade/updateStatus',
          method: 'post',
          params: {
            upgradeId: upgradeId,
            status: status
          }
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: this.$t('common.operationSuccess'),
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg || this.$t('common.operationFailed'))
          }
        }).catch((error) => {
          console.error('更新状态失败:', error)
          this.$message.error(this.$t('common.operationFailed'))
        })
      }).catch(() => {
        // 用户取消确认对话框，不需要处理
      })
    },
    // 删除
    deleteHandle(id) {
      this.$confirm(
        this.$t('upgrade.confirmDelete'), 
        this.$t('common.tip'), 
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.$http({
          url: `/jiaolianyuyue/upgrade/delete/${id}`,
          method: 'post'
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: this.$t('common.operationSuccess'),
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    // 重置搜索条件
    resetSearch() {
      this.searchForm = {
        appointmentId: '',
        upgradeType: '',
        status: ''
      }
      this.getDataList()
    },
    // 根据状态获取样式类型
    getStatusType(status) {
      switch (status) {
        case '申请中': return 'warning'
        case '已批准': return 'success'
        case '已拒绝': return 'danger'
        case '已完成': return 'primary'
        default: return 'info'
      }
    },
    // 获取状态多语言标签
    getStatusLabel(status) {
      switch (status) {
        case '申请中': return this.$t('upgrade.applying')
        case '已批准': return this.$t('upgrade.approved')
        case '已拒绝': return this.$t('upgrade.rejected')
        case '已完成': return this.$t('upgrade.completed')
        default: return status
      }
    }
  }
}
</script>

<style scoped>
.main-container {
  padding: 20px;
}
.form-container {
  margin-bottom: 20px;
}
</style> 